import _debounce from 'lodash/debounce';
import { signedUploadUrl  } from '../actions';
import { uploadFormUrl } from '../redux/tasks/actions';


export default async function uploadFilesHelper(files, dispatch) {
    const fileList = [];

    if (files?.length === 0 || !files) {
      return;
    }

    for (const file of files) {
      const uploadTaskResponse = await dispatch(uploadFormUrl({
        fileName: file.name,
        type: file?.type,
        fileSize: file?.size
        // taskId: task?._id,
      }));
      const fileId = uploadTaskResponse?.fileId;
      const signedUrl = uploadTaskResponse?.signedUrl;
      if (signedUrl) {
        fileList.push(fileId);
        await dispatch(signedUploadUrl(signedUrl, file));
      }
    }

    return fileList;
}